var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',_vm._b({ref:"parentGrid",on:{"add-button-clicked":_vm.addClick,"edit-button-clicked":_vm.editClick}},'Grid',{ ..._vm.props },false),[_c('UserAddEditForm',{ref:"addEditRef",on:{"submit-add-edit-form":_vm.onFormSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }